(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 74382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9605);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./components/common/index.js + 33 modules
var common = __webpack_require__(51633);
// EXTERNAL MODULE: ./components/widget-wrapper/WidgetWrapper.jsx + 33 modules
var WidgetWrapper = __webpack_require__(56090);
;// CONCATENATED MODULE: ./constants/schema.js
var homePageSchema = {
  '@context': 'https://schema.org ',
  '@type': 'TelecommunicationsService',
  name: 'Bakcell',
  alternateName: 'Azərbaycanın ən sürətli mobil şəbəkəsi',
  url: 'https://www.bakcell.com/ ',
  logo: 'https://www.bakcell.com/data/new-logo.svg',
  sameAs: ['https://www.facebook.com/Bakcell ', 'https://www.instagram.com/bakcell/ ', 'https://www.linkedin.com/company/bakcell/'],
  areaServed: {
    '@type': 'Country',
    name: 'Azerbaijan'
  },
  availableLanguage: [{
    '@type': 'Language',
    name: 'Azerbaijani'
  }, {
    '@type': 'Language',
    name: 'English'
  }, {
    '@type': 'Language',
    name: 'Russian'
  }],
  contactPoint: [{
    '@type': 'ContactPoint',
    telephone: '+994124988989',
    contactType: 'customer service',
    areaServed: 'AZ',
    availableLanguage: ['az', 'en', 'ru']
  }, {
    '@type': 'ContactPoint',
    telephone: '555',
    contactType: 'mobile support',
    areaServed: 'AZ',
    availableLanguage: ['az', 'en', 'ru']
  }, {
    '@type': 'ContactPoint',
    email: 'info@bakcell.com',
    contactType: 'information',
    availableLanguage: ['az', 'en', 'ru']
  }],
  serviceType: 'Mobile Telecommunications',
  provider: {
    '@type': 'Organization',
    name: 'Bakcell MMC'
  },
  hasPart: {
    '@type': 'WebSite',
    name: 'Bakcell',
    url: 'https://www.bakcell.com/ ',
    potentialAction: [{
      '@type': 'SearchAction',
      target: 'https://www.bakcell.com/search?q=%7Bsearch_term_string%7D&type=individual ',
      'query-input': 'required name=search_term_string'
    }, {
      '@type': 'SearchAction',
      target: 'https://www.bakcell.com/search?q=%7Bsearch_term_string%7D&type=corporate ',
      'query-input': 'required name=search_term_string'
    }]
  }
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./pages/index.js
/* eslint-disable @next/next/next-script-for-ga */







var __N_SSP = true;
/* harmony default export */ var pages = (/*#__PURE__*/react.memo(function Home(_ref) {
  var _parsedData$metadata, _parsedData$metadata2, _parsedData$metadata3, _parsedData$metadata4, _parsedData$metadata5;

  var data = _ref.data;
  var parsedData = JSON.parse(data);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(common/* Layout */.Ar, {
    navbar: parsedData === null || parsedData === void 0 ? void 0 : parsedData.menu,
    footer: parsedData === null || parsedData === void 0 ? void 0 : parsedData.footer,
    metadata: parsedData === null || parsedData === void 0 ? void 0 : parsedData.metadata,
    breadcrumbs: parsedData === null || parsedData === void 0 ? void 0 : parsedData.breadcrumbs,
    appDownload: parsedData === null || parsedData === void 0 ? void 0 : parsedData.app_download_widget,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata = parsedData.metadata) === null || _parsedData$metadata === void 0 ? void 0 : _parsedData$metadata.title) || (parsedData === null || parsedData === void 0 ? void 0 : parsedData.name)
      }), (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata2 = parsedData.metadata) === null || _parsedData$metadata2 === void 0 ? void 0 : _parsedData$metadata2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata3 = parsedData.metadata) === null || _parsedData$metadata3 === void 0 ? void 0 : _parsedData$metadata3.description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata4 = parsedData.metadata) === null || _parsedData$metadata4 === void 0 ? void 0 : _parsedData$metadata4.keywords) || (parsedData === null || parsedData === void 0 ? void 0 : (_parsedData$metadata5 = parsedData.metadata) === null || _parsedData$metadata5 === void 0 ? void 0 : _parsedData$metadata5.title) || 'Bakcell'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(homePageSchema)
        },
        type: "application/ld+json"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetWrapper/* default */.Z, {
      "data-testid": "widget-wrapper",
      widgets: parsedData === null || parsedData === void 0 ? void 0 : parsedData.widgets
    })]
  });
}));

/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(74382);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5443,1255,7847,6913,8922,5403,2030,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);